export enum UserSipHeaderTag {
  INTERFACE_GROUP_TAG = '0020',
  ALTERNATE_NAME = '0031',
}
